<template>
  <ErrorModal />
  <InfoModal />
  <q-dialog
    v-model="show"
    class="share-grant-main"
    style="width: 850px"
    full-width
  >
    <q-card class="share-dialog" style="width: 850px">
      <q-form @submit="contactConsultant()">
        <q-card-section class="header-section">
          <div
            class="text-h5 text-main bold-font"
            :class="!isVind ? 'portal-colors' : ''"
          >
            {{ t("scheme_details.contact_consultant_heading") }}
          </div>
        </q-card-section>

        <q-card-section :class="!isVind ? 'q-pa-none' : ''">
          <div class="share-text" :style="!isVind ? 'display:none' : ''">
            <div class="row subtext">
              <div class="column">
                <div class="row">
                  <div class="column">
                    <span class="share-info bold">
                      {{ t("scheme_details.contact_consultant_text") }}
                    </span>

                    <span class="share-info">
                      {{ grantName }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-card-section>
        <div class="row recipients-container">
          <div class="add-recipient">
            <div class="share-text-sm">
              <span class="share-info share-input">
                {{ t("share_and_download_schemes.name") }}
              </span>
              <q-input
                class="q-mt-sm"
                borderless
                bg-color="white"
                v-model="name"
                dense
                :rules="requiredFieldRule"
                :label="t('share_and_download_schemes.add_name')"
              />
            </div>

            <div v-if="isVind" class="share-text-sm">
              <span class="share-info share-input">
                {{ t("share_and_download_schemes.organization_name") }}
              </span>
              <q-input
                class="q-mt-sm input-share"
                borderless
                bg-color="white"
                v-model="accountName"
                dense
                :rules="requiredFieldRule"
                :label="t('share_and_download_schemes.add_organization')"
              />
            </div>

            <div v-if="isVind" class="share-text-sm">
              <span class="share-info share-input">
                {{ t("scheme_details.phone_number") }}
              </span>
              <q-input
                class="q-mt-sm input-share"
                borderless
                bg-color="white"
                v-model="phoneNumber"
                dense
                :rules="requiredFieldRule"
                :label="t('scheme_details.phone_number')"
              />
            </div>
            <div class="share-text-sm recipients">
              <span class="share-info share-input">
                {{ t("login.e-mail_address") }}
              </span>
              <q-input
                class="q-mt-sm mail-input"
                borderless
                bg-color="white"
                v-model="address"
                dense
                type="email"
                :rules="[isValidEmail, requiredFieldRule]"
                :label="t('share_and_download_schemes.add_email_address')"
              />
            </div>
          </div>
        </div>

        <q-card-section class="middle-section" v-if="isVind">
          <div class="share-text-sm">
            <span class="share-info">
              {{ t("share_and_download_schemes.message") }} *
            </span>
            <q-input
              :rules="requiredFieldRule"
              class="q-mt-sm textarea-input"
              v-model="message"
              outlined
              type="textarea"
              bg-color="white"
            />
          </div>
        </q-card-section>

        <q-card-actions class="q-mt-sm bold-font" align="left">
          <q-btn
            flat
            :label="t('search_schemes.share')"
            class="orange-btn-filled"
            color="white"
            no-caps
            style="width: 70px"
            type="submit"
          />
          <q-btn
            flat
            :label="t('common.cancel')"
            no-caps
            class="orange-btn-cancel"
            v-close-popup
            style="width: 100px"
            @click="clearInputs()"
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import { computed, ref, onMounted } from "vue";
import store from "../../store/index";
import MailingService from "../../services/mailing.service";
import ErrorModal from "../share-components/ErrorModal.vue";
import InfoModal from "../global-components/InfoModal.vue";
import { useI18n } from "vue-i18n";

export default {
  components: {
    ErrorModal,
    InfoModal,
  },
  setup() {
    onMounted(() => {
      store.commit(
        "infoModal/setInfoModalText",
        t("scheme_details.email_sent"),
      );
    });

    const { t } = useI18n();
    const show = computed({
      get: () => store.state.grantItems.showConsultantDialog,
      set: (val) =>
        store.commit("grantItems/updateShowConsultantDialog", {
          value: val,
          schemeName: "",
        }),
    });

    const grant = computed({
      get: () => store.state.grantItems.schemeNameForConsultantContact,
    });
    const grantName = computed(() => {
      return grant.value.replace(/<\/?span[^>]*>/g, "");
    });

    const contactConsultant = async () => {
      var messageData = {
        message: message.value,
        organisationNameFromPopup: accountName.value,
        nameFromPopup: name.value,
        emailFromPopup: address.value,
        phoneNumber: phoneNumber.value,
        schemeName: grantName.value,
        schemeLink: window.location.href,
      };

      await MailingService.contactConsultant(messageData);

      store.commit("grantItems/updateShowConsultantDialog", {
        value: false,
        schemeName: "",
      });
      clearInputs();
    };

    const address = ref("");
    const message = ref("");
    const accountName = ref("");
    const name = ref("");
    const phoneNumber = ref("");

    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
    });
    const clearInputs = () => {
      message.value = "";
      address.value = "";
      accountName.value = "";
      name.value = "";
      phoneNumber.value = "";
    };

    return {
      phoneNumber,
      contactConsultant,
      show,
      t,
      clearInputs,
      isVind,
      name,
      accountName,
      message,
      address,
      grant,
      grantName,
      requiredFieldRule: [
        (val) => {
          return (val && val.length > 0) || t("common.required_field");
        },
      ],
      isValidEmail(val) {
        const emailPattern =
          /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        if (
          (name.value && (accountName.value || isVind.value == false)) ||
          address.value
        )
          return emailPattern.test(val) || t("common.invalid_email_address");
      },
    };
  },
};
</script>
